export type { ModalProps } from './modal-props.interface';
export * from './modal-overrides.const';
export { Modal } from './modal';
